// -- other --
import React,{useEffect,useState,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/img";
import Select from "react-select";
import {Toaster} from 'react-hot-toast';
import series from 'async/series';
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Response_Logic,Log,Num,Str,DateTime,Status_Type} from "biz9-utility";
import {Message,Title,Project_Table,Config,Type} from "../../../constant";
import {Image,Style,User,Toast_Message,Storage,App} from "../../../project";
import {Cart_Logic,Store_Title,Store_Type,Order_Logic} from "biz9-store";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Portal_Table,Portal_Type,Portal_Remote_Store_Cart,Portal_Remote_Store_Order,Portal_Remote_Data,Portal_Url} from "biz9-portal-app";
// -- stripe --
import {loadStripe} from '@stripe/stripe-js';
import {PaymentElement,Elements,useStripe,useElements} from '@stripe/react-stripe-js';

const Product_App_CheckOut = () => {
    /* -- DEFINE -- *
     * --- BUTTONZ ---
    //* btn_post_checkout - redirect to card checkout. --old
     * btn_post_login - redirect to login.
     *
     */
    const query = UrlQuery();
    const [user,setUser] = useState(User.get());
    const [cart,setCart] = useState(Data_Logic.get(Portal_Table.CART,0,{data:{grand_total:0,cart_items:[]}}));

    const [product,setProduct] = useState(Data_Logic.get(Portal_Table.PRODUCT,0));
    const [cart_sub_items,setCartSubItems] = useState([]);
    const [payment_plans,setPaymentPlans] = useState([]);
    const [val_payment_plan,setValPaymentPlan] = useState(payment_plans.find(option => option.id === 1));
    const [val_payment_amount,setValPaymentAmount] = useState("");
    const [val_hide_billing,setValHideBilling] = useState(false);
    const [val_hide_login,setValHideLogin] = useState(true);
    const [val_payment_plan_type,setValPaymentPlanType] = useState(Store_Type.ORDER_PAYMENT_PLAN_1);
    // -- stripe --
    const stripePromise = loadStripe(Config.STRIPE_KEY);
    const [clientSecret, setClientSecret] = useState('');
    const options = { clientSecret };
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            },[]);
    async function get_data() {
        // -- get-cart --  get-stripe-payment-intent -- data-response --
        let cart = Storage.get_cart();
        const [biz_response,biz_data] = await Portal_Remote_Store_Cart.get_stripe_session(App.get_url(Portal_Url.STORE_STRIPE_GET_PAYMENT_INTENT),cart);
        setClientSecret(biz_data.client_secret);
        bind_items(cart);
    };
    async function bind_items(data){
        // -- cart --
        setCart(Cart_Logic.get_total(data));
        // -- product --
        setProduct(data.cart_items[0].parent);
        // -- cart-sub-items --
        setCartSubItems(data.cart_items[0].parent);
    };
    async function post_order() {
        let response = Response_Logic.get();
        let order = Order_Logic.get(cart,{cart_code:'OR'});
        let post_app = false;
        series([
                async function(call) {
                    // -- post-order -- data-response --
                    let order_payment = Order_Logic.get_order_payment(order.order_number,Store_Title.ORDER_PAYMENT_METHOD_TEST,cart[Portal_Type.PAY_NOW_COST]);
                    const [biz_response,biz_data] = await Portal_Remote_Store_Order.post(App.get_url(Portal_Url.STORE_ORDER_POST),order,[order_payment]);
                    response = biz_response;
                    order = biz_data;
                    if(response.status == Status_Type.SUCCESS){
                        Storage.post_order(order);
                        post_app = true;
                    }
                },
                async function(call) {
                // -- post-app -- data-response --
                if(response.status == Status_Type.SUCCESS && post_app){
                let app = Data_Logic.get(Project_Table.APP,0,{data:{
                    app_id:Str.get_id(9999,{non_zero:true}),
                    user_id:User.get().id,
                    app_category:cart[Type.APP_CATEGORY],
                    app_type:cart[Type.APP_TYPE],
                    order_number:order[Type.ORDER_NUMBER],
                }
                });
                const [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),app.table,app);
                    window.location.href = all_routes.product_app_checkout_success;
                }else{
                    Toast_Message.error(response.message);
                }
            },
            ], function(err, results) {
            });
        }
const updateValPaymentPlan = (selectedOption) => {
    setValPaymentPlan(selectedOption);
    setValPaymentAmount(selectedOption.value);
    setValPaymentPlanType(selectedOption.id);
};
// -- stripe-checkout-form -- redirect -- start --
const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        Toast_Message.loading(Message.PROCCESSING_PAYMENT);
        const { error } = await stripe.confirmPayment({
                elements,
                confirmParams: {
return_url: 'http://localhost:3000/checkout',
},
redirect: 'if_required',
});
if (error) {
    console.log(error);
    setMessage(error.message);
    Toast_Message.error(error.message);
} else {
    setMessage('Payment successful!');
    Toast_Message.success('Payment successful!');
    post_order();
}
setIsLoading(false);
};
return (
        <form onSubmit={handleSubmit}>
        <PaymentElement
        onReady={() => {
        setIsLoading(false);
        Toast_Message.dismiss();
        }}
        />
        <button disabled={isLoading || !stripe || !elements}  hidden={user.is_guest} id="submit" className="btn btn-primary mb-0 w-100 mt-5">
        <span>{isLoading ? 'Loading...' : 'Pay Now'}</span>
        </button>
        {message && <div id="payment-message" className='mt-3'>{message}</div>}
        </form>
       );
};
// -- stripe-checkout-form -- redirect -- end --
return (
        <>
        <Toaster />
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="breadcrumb-img">
        <div className="breadcrumb-left">
        <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
        </div>
        </div>
        <div className="container">
        <div className="row">
        <div className="col-md-12 col-12">
        <h2 className="breadcrumb-title mb-0">
        Checkout <span className="text-primary" />
        </h2>
        </div>
        </div>
        </div>
        </div>
        {/* /Breadcrumb */}
{/* Page Content */}
<div className="page-content">
<div className="container">
<div className="row">
{/* FULL-ROW-START */}
<div className="col-lg-8" >
{/* BILLING-START */}
<div className="login-card mb-3 mb-lg-0"hidden={user.is_guest}>
<div className="login-heading text-start mb-4">
<h5>{Title.LABEL_BILLING_DETAILS}</h5>
</div>
<div className="row">
<div className="col-lg-12">
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">
{" "}
UserName <span className="text-primary">*</span>
</label>
<input type="text" value={user.username} disabled={true} className="form-control floating" />
</div>
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">
{" "}
Email <span className="text-primary">*</span>
</label>
<input type="text" value={user.email} disabled={true} className="form-control floating" />
</div>
</div>
</div>
</div>
{/* BILLING-END */}
{/* LOGIN-START */}
<div className="login-card mb-3 mb-lg-0" hidden={!user.is_guest}>
<div className="login-heading text-start mb-4">
<h5>{Title.LABEL_LOGIN_CHECKOUT}</h5>
</div>
<div className="row">
<div className="col-lg-12">
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">
{" "}
</label>
<Link id='btn_post_login' to={all_routes.login}  className="btn btn-primary mb-0 w-50">
Login
</Link>
</div>
</div>
</div>
</div>
{/* LOGIN-END */}
</div>
{/* FULL-ROW-END */}
<div className="col-lg-4">
{/* Order details */}
<div className="service-widget member-widget mb-0">
<h5 className="service-head d-flex align-items-center">
Order Details {" "}
</h5>
<div className="user-details bg-light p-3 mb-16">
<div style={{display: !product.image_filename ? 'none' : 'block'}} className="user-img">
<ImageWithBasePath
src={Image.get_url(product.image_filename,Image_Format.SQUARE_THUMB)}
alt="img"
/>
</div>
<div className="user-info">
<h5>
<span className="me-2">
<Link to={"/app/"+product.title_url}>
{product.title}
</Link>
</span>{" "}
</h5>
<p><b>Type :</b> {product.type}</p>
<p>Delivery : {App.get_app_delivery_time(product.cost)}</p>
<p>Payment Plan: {cart[Type.PAYMENT_PLAN_TYPE]}</p>
</div>
</div>
<ul className="member-info">
{cart.cart_items.map((item) => (
            <>
            <li key={Num.get_id()} >{item.parent.title}
            <span>{Str.get_money(item.cost)}</span>
            </li>
            <ul>
            {item.cart_sub_items.map((sub_item) => (
                        <li  key={Num.get_id()} >
                        {sub_item.parent.type}{" "}{sub_item.parent.category}{": "}{sub_item.parent.title}
                        <span>{Str.get_money((parseInt(sub_item.cost) * parseInt(sub_item.quanity)))}</span>
                        </li>
                        ))}
            </ul>
            </>
            ))}
</ul>
<div className="about-me ">
<h5 className="d-flex justify-content-between align-items-center">
Total <span> {Str.get_money(cart.grand_total)}</span>
</h5>
</div>
<div className="about-me ">
<h4 className="d-flex justify-content-between align-items-center"  hidden={!user.is_guest}>
Pay Now <span> {Str.get_money(cart.pay_now_cost)}</span>
</h4>
</div>
{/*<Link to={"#"} onClick={btn_post_checkout} hidden={user.is_guest === true} className="btn btn-primary mb-0 w-100">
   Pay {Str.get_money(val_payment_amount)}
   </Link>
   */}
{clientSecret && (
        <Elements stripe={stripePromise} options={options}>
        <CheckoutForm />
        </Elements>
        )}
</div>
{/* Order details */}
</div>
</div>
</div>
</div>
{/* /Page Content */}
</>
);
};
export default Product_App_CheckOut;
